var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconJoin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 104,
    height: 104,
    viewBox: "0 0 104 104",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_345",
    "data-name": "\\uADF8\\uB8F9 345",
    transform: "translate(-990 -628)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_275",
    "data-name": "\\uD328\\uC2A4 275",
    d: "M52,0A52,52,0,1,1,0,52,52,52,0,0,1,52,0Z",
    transform: "translate(990 628)",
    fill: "#009fe2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_274",
    "data-name": "\\uD328\\uC2A4 274",
    d: "M9738.7-2511.562l15.146,16.141,29.367-38.4",
    transform: "translate(-8719.203 3194.319)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 12
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconJoin);
export default __webpack_public_path__ + "static/media/icon_join.0e9bc95a03e559965dd9d129281f756e.svg";
export { ForwardRef as ReactComponent };